import { Route } from "lucide-react";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  /** true = light logo for dark backgrounds */
  dark?: boolean;
  /** sm = footer/compact, md = header/sidebar, lg = branding panels */
  size?: "sm" | "md" | "lg";
}

const sizes = {
  sm: { icon: 16, text: "text-base", gap: "gap-1.5" },
  md: { icon: 20, text: "text-lg", gap: "gap-2" },
  lg: { icon: 28, text: "text-2xl", gap: "gap-2.5" },
};

export function Logo({ className, dark = false, size = "md" }: LogoProps) {
  const s = sizes[size];

  return (
    <div
      className={cn(
        "flex items-center select-none",
        s.gap,
        className
      )}
    >
      <div
        className={cn(
          "flex items-center justify-center rounded-lg",
          size === "lg" ? "h-10 w-10" : size === "md" ? "h-8 w-8" : "h-6 w-6",
          dark
            ? "bg-primary/20"
            : "bg-primary/10"
        )}
      >
        <Route
          size={s.icon}
          strokeWidth={2.5}
          className="text-primary"
        />
      </div>
      <span
        className={cn(
          s.text,
          "font-bold tracking-tight",
          dark ? "text-white" : "text-foreground"
        )}
        style={{ fontFamily: "'Space Grotesk', sans-serif" }}
      >
        kilometrit
        <span className="text-primary">.fi</span>
      </span>
    </div>
  );
}
